var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.componentClass,on:{"click":_vm.setActive}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.title)+" ")],{"title":_vm.title})],2)}
var staticRenderFns = []

export { render, staticRenderFns }